import React, {useState} from "react";
import { withStyles } from "@mui/styles";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select'
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from '@mui/icons-material/FileCopy';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from "@mui/icons-material/Close";

import Typography from "@mui/material/Typography";
import { teal, grey } from "@mui/material/colors";

import ColorButton from './ColorButton'
import AlertDialog from './AlertDialog'
import {APIPostcodeSearch} from './Api'
import countries from './countries'



const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 300,
    },
  },
};
const WireInfo = (props) => {
  const emptycontact = {id:0,title:'',first:'',last:'',position: '',email:'',homephone:'',workphone:'',mobilephone:'', notes: ''}
  const emptyaddress = {country: "",town: "",county: "",postcode: "",address1: "",address2: "",address3: "",additionalinfo: ''}

  const { classes, onClose } = props;
  const [showcontactform,setShowContactfrom] = useState(false)
  const [site_name,setSiteName] = useState(props.site_name || '')
  // Merge with emptyaddress to ensure all fields have default values (fixes controlled/uncontrolled warning)
  const [address, setAddress] = useState({...emptyaddress, ...(props.address || {})});
  const [contacts, setContacts]=useState(Array.isArray(props.contacts) ? [...props.contacts] : [])
  const [tmpcontact, setTempContact]=useState(emptycontact) // Used for editing stage
  // The following are used for the AlertDialog - So we have one Dialog in the render and set
  // The variables when we need the Dialog to be show (setShowAlertDialog(true) triggers the show and false will hide it.)
  const [showalertdialog, setShowAlertDialog] = useState(false)
  const [alertText,setAlertText] = useState('')
  const [confText,setConfText] = useState('')
  const [adclosefnc, setADCloseFnc] = useState() // Set the Alert Dialog Close Function
  const [showopen, setShowOpen] = useState(true)
  const [showclose, setShowClose] = useState(true)
  const [dialogtitle,setDialogTitle] = useState('confirmation')
  const [pcresults, setPCResults] = useState([])
  const [pafaddress, setPAFAddress] = useState(0)

  // Dont Show the Component unless props.open is true
  if(props.open === false)
    return (false)
  
    


  const CloseForm = () => {onClose(false);}

  const handleOnCloseConfirmDialog = () => {
    setAlertText(`You are about to Close the "${props.type}" form. Have you SAVED all any changes before doing so?`)
    setConfText("Are you SURE you wish to Close the form?")
    setShowOpenCose(true,true)
    setDialogTitle('Confirm Close Dialog')
    setADCloseFnc(() => confirmCloseDialog)
    setShowAlertDialog(true)
    
    const confirmCloseDialog = (status) => {
      setShowAlertDialog(false)
      if(status)
          CloseForm()
    }
  }

  const handleSaveSite = () => {
    const siteData = {
      site_id: props.site_id,
      site_name,
      address: {...address},
      contacts: [...contacts]
    }
    props.onSave({...siteData})
    CloseForm()
  }



  const EditContacts = (index, item) => {
    setTempContact({...contacts[item.id]}) // Create a copy for editing and will be committed to contacts when saved
    setShowContactfrom(true)
  }

  const handleUpdateAddressField = (event) => {

    const fld = event.target.id??event.target.name
    let tmpaddr = address
    tmpaddr[fld] = event.target.value
    setAddress({...tmpaddr})
  }



  const handleCancelSave = () => {
    setAlertText('By Clicking the "Yes" Button you will LOOSE all of the information you have enterd for this Contact.')
    setConfText("Are you SURE you wish to Cancel?")
    setShowOpenCose(true,true)
    setDialogTitle('Confirm Cancel Save')
    setADCloseFnc(() => handleCancelSaveAlert)
    setShowAlertDialog(true)
    
    const handleCancelSaveAlert = (status) => {
      setShowAlertDialog(false)
      setShowContactfrom(!status)
    }
  }


  const handleSaveConact = () => {
    // Committ our changes from tmpcontact to contacts
    let found = false
    let cons = [...contacts]
    let il = contacts.length;
    for(let i=0; i<il; i++) {
      if(cons[i].id === tmpcontact.id) {
        found = true;
        cons[i] = {...tmpcontact}
        break;
      }
    }
    if(!found)
      cons.push(tmpcontact)
    setContacts(cons)

      
    // and Alert User.
    setAlertText('Just to Confirm your changes have been saved on this form but will not be updated untl the Save Button is Selected in the top Right .')
    setConfText("Press Yes to Continue")
    setShowOpenCose(true,false)
    setDialogTitle('Information')

    const ClosehandleSaveContactDialog =() => {
      setShowAlertDialog(false)
      setShowContactfrom(false)
    }
    setADCloseFnc(() => ClosehandleSaveContactDialog)
    setShowAlertDialog(true)
  }



  // Just to reduce the lines of code needed everytime we have to set these
  const setShowOpenCose = (openval,closeval) => {
      setShowOpen(openval)
      setShowClose(closeval)
  }

  const getContactDetailForDisplay= (c) => {
    if(c.mobilephone ) return c.mobilephone
    if(c.workphone) return c.workphone
    if(c.homephone) return c.homephone
    return c.email
  }

  const PostcodeLookup = async () => {
    const postcode = address.postcode
    const results =  await APIPostcodeSearch(postcode)
    if(results && results.length > 0 && !results[0].error)
      setPCResults([...results])
    else {
      setAlertText(`Sorry no Addresses could be found for Postcode ${postcode}. Please check the Postcode you entered and try again!`)
      setConfText("Press Yes to Continue")
      setShowOpenCose(true,false)
      setDialogTitle('Information')
      setADCloseFnc(() => CloseInfoDialog )
      setShowAlertDialog(true)
    }
  }

  const CloseInfoDialog = () => {
    setShowAlertDialog(false)
  }

  const handlePAFChange = (event) => {
    let paf = pcresults[event.target.value].paf
    let addrcopy = address
    addrcopy.address1 = paf.line_1??''
    addrcopy.address2 = paf.line_2??''
    addrcopy.address3 = paf.line_3??''
    addrcopy.town = paf.post_town??''

    // If town and county are the same blank the town.
    let county = (paf.county??paf.postal_county)??''
    if(paf.post_town==paf.county || paf.post_town == paf.postal_county )
      county = ''
    addrcopy.county = county
    addrcopy.country = paf.country??''
    addrcopy.postcode = paf.postcode??''
    setAddress({...addrcopy})
    setPAFAddress(event.target.value)
  }

  const AddNewContact = () => {
    let cons = [...contacts]
    let tempc = {...emptycontact}
    let im = Math.max(...cons.map(o=>o.id))+1
    tempc.id=im;
    setTempContact(tempc)
    setShowContactfrom(true)
  }

  const handleCopyFromContact= (index) =>  {
    let prev = {...contacts[index]}
    let im = Math.max(...contacts.map(o=>o.id))+1
    prev.id=im;
    prev.notes = `${prev.notes}\n\nCopied from contact ${prev.title} ${prev.first} ${prev.last} on ${new Date()}`
    setTempContact(prev)
    setShowContactfrom(true)
   
  }

  const updateContactField = (e) => {
    let con = {...tmpcontact}
    con[e.target.id] = e.target.value
    setTempContact({...con})
  }


  const DeleteConact = (idx) => {
    setAlertText("This Action will delete the contact from the list of Contacts. Are you sure you wish to Delete?")
    setConfText("Press Yes to Delete or No to Cancel")
    setDialogTitle('Delete Contact Confirmation')
    setShowOpenCose(true,true)
    setADCloseFnc(()=>DoDelete)
    setShowAlertDialog(true)

    const DoDelete = (status) => {
      if(status) {
        let tmpc = contacts
        tmpc.splice(idx,1)
        setContacts(tmpc)
      }
      setShowAlertDialog(false)
    }

  }

  return (
    <Dialog
      className={classes.root}
      fullWidth
      maxWidth="md"
      open={props.open} //props.open?true:false
      onClose={onClose}
    >
      <DialogTitle >
      <Grid container>
          <Grid item xs={12}>
            <Grid container direction="row" className={classes.mainHeader}>
              <Grid item xs={6}>
                <Typography className={classes.primaryColor} variant="h6">
                  {props.type}
                </Typography>
              </Grid>
              <Grid item xs={6} align="right" className={classes.padding}>
                <IconButton
                  edge="start"
                  align="right"
                  color="inherit"
                  aria-label="Close"
                  style={{ padding: 2 }}
                  onClick={() => handleOnCloseConfirmDialog()}
                  //className={classes.padding}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>

              <Grid item xs={8}>
                <TextField
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  label="Site Name"
                  id="site_name"
                  value={site_name}
                  onChange={(event)=>setSiteName(event.target.value)}
                />
              </Grid>

              <Grid item xs={4} align="right" >
                <Button onClick={() => handleOnCloseConfirmDialog()}>Cancel</Button>
                <Button onClick={() => handleSaveSite()}>SAVE</Button>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
          </Grid>
        </Grid>
      </DialogTitle>
      {showalertdialog && <AlertDialog open={(showalertdialog??false)} okPrompt="Yes" cancelPrompt="No" content={alertText} conftext={confText} onClose={adclosefnc}  showclose={showclose} showopen={showopen} title={dialogtitle} /> }

      <DialogContent className={classes.padding}>

        <Grid container>
          <Grid
            container
            direction="row"
            className={classes.mainContent}
            spacing={1}
          >
            <Grid item xs={5}>
              <Grid item xs={6}>
                <Typography>Site Address Details</Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  label="Address"
                  id="address1"
                  value={address.address1 || ''}
                  onChange={(event)=>handleUpdateAddressField(event)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  label=""
                  id="address2"
                  value={address.address2 || ''}
                  onChange={(event)=>handleUpdateAddressField(event)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  label=""
                  id="address3"
                  value={address.address3 || ''}
                  onChange={(event)=>handleUpdateAddressField(event)}
                />
              </Grid>
              <Grid item xs={7}>
                <TextField
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  label="town"
                  id="town"
                  value={address.town || ''}
                  onChange={(event)=>handleUpdateAddressField(event)}
                />
              </Grid>
              <Grid item xs={7}>
                <TextField
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  label="County"
                  id="county"
                  value={address.county || ''}
                  onChange={(event)=>handleUpdateAddressField(event)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  margin="dense"
                  variant="outlined"
                  label="Postcode"
                  id="postcode"
                  value={address.postcode || ''}
                  onChange={(event)=>handleUpdateAddressField(event)}
                />
                <ColorButton onClick={PostcodeLookup} style={{padding: '5px', marginTop: '12px', fontSize: '14px' }} primary="#04c659" secondary="darkgreen">Search</ColorButton>
              </Grid>
              {pcresults.length > 0  && 
                <React.Fragment>
                  <Grid item xs={12}>
                    Please Select an Address from the List Below<br/>
                  </Grid>
                  <Grid item xs={12} >
                    <br/>
                  <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                      <Select
                        labelId="demo-select-small"
                        id="demo-select-small"
                        value={pafaddress}
                        label="pafaddress"
                        onChange={handlePAFChange}
                      >
                        {pcresults.map((item) =>{
                          return(
                            <MenuItem key={`paf_${item.index}`} value={item.index}>{item.text}</MenuItem>
                          )
                        })}

                      </Select>
                    </FormControl>
                    <br/>
                  </Grid>

                </React.Fragment>
              
              }
              <Grid item xs={10}>
              <FormControl fullWidth={true} margin="dense" sx={{m:1, minWidth: 350}}  >
                <InputLabel id="country-label">Country</InputLabel>
                  <Select
                  labelId="country-label"
                  label="Country"
                  fullWidth={true}
                  margin="dense"
                  variant="outlined"
                  value={address.country || ''}
                  id="country"
                  name="country"
                  onChange={handleUpdateAddressField}
                >
                    <MenuItem key={0} value="" >
                      Please Select A Country
                    </MenuItem>
                  {countries.map((option,index) => (
                    <MenuItem key={index+1} value={option.name} >
                      {option.name}
                    </MenuItem>
                  ))}
                  </Select>
                  </FormControl>

              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  margin="dense"
                  multiline
                  rows="5"
                  variant="outlined"
                  label="Additional Info"
                  id="additionalinfo"
                  value={address.additionalinfo || ''}
                  onChange={(event)=>handleUpdateAddressField(event)}
                />
              </Grid>
            </Grid>
            <Grid item xs={1} ></Grid>
            <Grid item xs={6} >
              <Grid container>
                <Grid item xs={6} >
                  <Typography>Contact Details</Typography>
                </Grid>
                <Grid align="right" item xs={6} >
                  <ColorButton onClick={()=>{AddNewContact()}} style={{display: "inline", fontSize: "12px"}} >Add New Contact</ColorButton>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <br/>
                <Divider />
              </Grid>
              <Grid container>
                <Grid
                  container
                  direction="row"
                  className={classes.mainContent2}
                  spacing={1}
                >
                {contacts.map((item, index) => {
                    return (
                        <React.Fragment key={`conact_list_${index}`}>
                          <Grid item xs={9} style={{fontSize: '14px'}}>
                            {item.title}&nbsp;{item.first}&nbsp;{item.last}&nbsp;-&nbsp;{getContactDetailForDisplay(item)}
                          </Grid>
                          <Grid item xs={3} style={{fontSize: '12px'}}>
                            <IconButton size="small" onClick={()=>EditContacts(index,item)}  >
                              <EditIcon style={{fontSize: '12px'}} />
                            </IconButton>
                            <IconButton size="small" onClick={()=>handleCopyFromContact(index)}>
                              <ContentCopyIcon  style={{fontSize: '12px'}}  />
                            </IconButton>
                            <IconButton size="small" onClick={()=>DeleteConact(index)}>
                              <DeleteIcon  style={{fontSize: '12px'}}  />
                            </IconButton>

                          </Grid>
                          <Grid item xs={12}><Divider/></Grid>
                        </React.Fragment>

                        )
                      }
                    )
                  }
                  </Grid>
                </Grid>
                {showcontactform  &&
                    <React.Fragment>
                      <Grid item xs={12}>Edit Contact Details</Grid>
                      <Grid item xs={12}>
                      <TextField
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        label="Title"
                        id="title"
                        value={tmpcontact.title}
                        onChange={(event)=>updateContactField(event)}
                      />

                      <TextField
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        label="Firtname"
                        id="first"
                        value={tmpcontact.first}
                        onChange={(event)=>updateContactField(event)}
                      />
                      <TextField
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        label="Surname"
                        id="last"
                        value={tmpcontact.last}
                        onChange={(event)=>updateContactField(event)}
                      />
                      <TextField
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        label="Email"
                        id="email"
                        value={tmpcontact.email}
                        onChange={(event)=>updateContactField(event)}
                      />
                      <TextField
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        label="Mobile Phone"
                        id="mobilephone"
                        value={tmpcontact.mobilephone}
                        onChange={(event)=>updateContactField(event)}
                      />
                      <TextField
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        label="Work Phone"
                        id="workphone"
                        value={tmpcontact.workphone}
                        onChange={(event)=>updateContactField(event)}
                      />
                      <TextField
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        label="Home Phone"
                        id="homephone"
                        rows="1"
                        value={tmpcontact.homephone}
                        onChange={(event)=>updateContactField(event)}
                      />
                      <TextField
                        fullWidth
                        margin="dense"
                        rows="1"
                        variant="outlined"
                        label="Position / Relation / Customer"
                        id="position"
                        value={tmpcontact.position}
                        onChange={(event)=>updateContactField(event)}
                      />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          margin="dense"
                          multiline
                          rows="5"
                          variant="outlined"
                          label="Notes"
                          id="notes"
                          value={tmpcontact.notes}
                          onChange={(event)=>updateContactField(event)}
                        />
                      </Grid>
                      <Grid item xs={12} >
                        <ColorButton primary="#ff0000" secondary="darkred" onClick={handleSaveConact} >Save</ColorButton>
                        <ColorButton primary="#04c659" secondary="darkgreen" onClick={handleCancelSave} >Canel</ColorButton>
                      </Grid>
                      <Grid item xs={12}>
                        <br/>
                        <Divider />
                        <br/>
                      </Grid>
                    </React.Fragment>
                  }
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  primaryColor: {
    color: teal[500],
  },
  secondaryColor: {
    color: grey[700],
  },

  padding: {
    padding: 0,
  },
  mainHeader: {
    backgroundColor: grey[100],
    padding: 20,
    alignItems: "center",
  },
  mainHeaderRight: {
    backgroundColor: grey[100],
    padding: 10,
    alignItems: "center",
  },
  mainContent: {
    padding: 40,
  },
  mainContent2: {
    padding: 10,
  },
  secondaryContainer: {
    padding: "20px 25px",
    backgroundColor: grey[200],
  },
});

export default withStyles(styles)(WireInfo);

